import { battleEventSchema } from '@shared/api';
import { openRoomSocket } from '@shared/lib/room-socket';
import type { BattleChannel, BattleSocketHandlers } from './types';
export const openBattleSocket = (code: string, handlers: BattleSocketHandlers): BattleChannel =>
  openRoomSocket('/secured/battles/ws', code, (value) => battleEventSchema.safeParse(value), handlers);
